<mat-card style="border-color: #5775a8;">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <mat-icon style="color: white;">settings</mat-icon>
      <span style="font-size: large; color: white;">
        Business Merge
      </span>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div *ngIf="!showNext" class="flex flex-col items-center w-full">

      <div class="flex flex-col items-center w-full">
        <br />
        <div class="flex flex-row rounded-lg w-4/5">
          <table class="w-full">
            <tr style="padding-bottom: 10px;">
              <th>Business Id</th>
              <th>Status </th>
              <th>Business Name</th>
              <th>Address 1</th>
              <th>Address 2</th>
            </tr>
            <tr>
              <td style="text-align: center;">{{currentBusiness.id}}</td>
              <td style="text-align: center;">
                <span *ngIf="currentBusiness.active" style="color:green;">Active</span>
                <span *ngIf="!currentBusiness.active" style="color:red;">Inactive</span>
                <span *ngIf="currentBusiness.active" style="color:green;"> [EXEMPT]</span>
              </td>
              <td style="text-align: center;">{{currentBusiness.businessName}}</td>
              <td style="text-align: center;">{{currentBusiness.businessAddress1}}</td>
              <td style="text-align: center;">{{currentBusiness.businessAddress2}}</td>
            </tr>
            <tr>
              <th>City</th>
              <th>State </th>
              <th>Zip</th>
              <th>County</th>
              <th>Complaints</th>
            </tr>
            <tr>
              <td style="text-align: center;">{{currentBusiness.businessCity}}</td>
              <td style="text-align: center;">{{currentBusiness.stateId}}</td>
              <td style="text-align: center;">{{currentBusiness.businessZip}} <span
                  *ngIf="currentBusiness.businessPhoneExt != null"> - {{currentBusiness.businessPhoneExt}} </span></td>
              <td style="text-align: center;">{{currentBusiness.countyName}}</td>
              <td style="text-align: center;">{{currentBusiness.totalComplaints}}</td>
            </tr>
          </table>

        </div>

      </div>

      <hr style="border: 1px solid gray;">

      <div class="flex flex-col items-center w-full">
        <br />

        <div class="flex flex-col w-full">
          <form [formGroup]="form">
            <div class="flex flex-row w-full">
              <div class="flex flex-row">
                <div>
                  <mat-form-field class="container">
                    <mat-label>Search Text</mat-label>
                    <input matInput formControlName="searchText" placeholder="Enter search text here">
                  </mat-form-field>
                </div>
                <div>
                  <button mat-raised-button (click)="getSearchBusinessData()" class="m-8" style="background: #7ABDF3;">
                    <mat-icon>search</mat-icon>
                    Search
                  </button>
                </div>
              </div>
              <div class="justify-end">
                <input (keyup)="filterTable($event)" placeholder="Search" [value]="filter" />
              </div>
            </div>
          </form>
          <hr style="border: 1px solid gray;">

          <div class="flex flex-row w-full">

            <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #MatSort="matSort" class="w-full">

              <ng-container matColumnDef="selected">
                <th mat-header-cell *matHeaderCellDef>Select</th>
                <td mat-cell *matCellDef="let business">

                  <mat-radio-button (click)="radioChange(business.id)"></mat-radio-button>

                </td>
              </ng-container>

              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
                <td mat-cell *matCellDef="let business">{{business.id}}
                </td>
              </ng-container>
              <ng-container matColumnDef="businessName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let business">
                  <!-- <a (click)="rowClick(business)">{{business.businessName}}</a> -->
                </td>
              </ng-container>
              <ng-container matColumnDef="active">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let business">
                  <span *ngIf="business.active" style="color: green;">Yes</span>
                  <span *ngIf="!business.active" style="color: red;">No</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="exempt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Exempt</th>
                <td mat-cell *matCellDef="let business">
                  <span *ngIf="business.exempt" style="color: green;">Yes</span>
                  <span *ngIf="!business.exempt" style="color: red;">No</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="businessAddress1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                <td mat-cell *matCellDef="let business">{{business.businessAddress1}}</td>
              </ng-container>
              <ng-container matColumnDef="businessCity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
                <td mat-cell *matCellDef="let business">{{business.businessCity}}</td>
              </ng-container>
              <ng-container matColumnDef="businessZip">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip</th>
                <td mat-cell *matCellDef="let business">{{business.businessZip}}</td>
              </ng-container>
              <ng-container matColumnDef="countyName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>County</th>
                <td mat-cell *matCellDef="let business">{{business.countyName}}</td>
              </ng-container>
              <ng-container matColumnDef="totalComplaints">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaints</th>
                <td mat-cell *matCellDef="let business" style="text-align: center;">{{business.totalComplaints}}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

            </table>

          </div>
          <hr style="border: 1px solid gray;">
          <br />
        </div>

        <div class="flex flex-row w-full">
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="cancel()" class="m-8 container">
              Cancel
            </button>
          </div>
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="next()" class="m-8 container" style="background: #7ABDF3;">
              Next <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>

      </div>

    </div>

    <div *ngIf="showNext" class="flex flex-col items-center w-full">
      <div *ngIf="!showSuccess" class="flex flex-col items-center w-full">
        <div class="flex flex-row items-center w-full">
          Please confirm the following and press the &nbsp;<span style="font-weight: bold;"> Merge </span>&nbsp; button
          below.
        </div>
        <hr class="w-full" style="border: 1px solid gray;">
        <div class="flex flex-row items-center w-full">
          <div class="flex flex-row panel panel-success w-2/5">
            <mat-card-content>
              <div class="flex flex-row">
                Business To Merge
              </div>

              <div class="flex flex-col rounded-lg panel-body" style="border: 1px;border-color: grey;">
                <hr class="w-full" style="border: 1px solid gray;">
                <table>
                  <tr>
                    <td><span style="font-style: bold;">Business Id</span></td>
                    <td>{{currentBusiness.id}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Business Name</span></td>
                    <td>{{currentBusiness.businessName}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Business Status</span></td>
                    <td>
                      <span *ngIf="currentBusiness.active" style="color: green;">Active</span>
                      <span *ngIf="!currentBusiness.active" style="color: red;">Inactive</span>
                    </td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Address 1</span></td>
                    <td>{{currentBusiness.businessAddress1}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Address 2</span></td>
                    <td>{{currentBusiness.businessAddress2}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">City</span></td>
                    <td>{{currentBusiness.businessCity}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">State</span></td>
                    <td>{{currentBusiness.stateId}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Zip</span></td>
                    <td>
                      {{currentBusiness.businessZip}}
                      <span *ngIf="currentBusiness.businessPhoneExt != null && currentBusiness.businessPhoneExt != ''">
                        - {{currentBusiness.businessPhoneExt}}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">County</span></td>
                    <td>{{currentBusiness.countyName}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Complaints</span></td>
                    <td>{{currentBusiness.totalComplaints}}</td>
                  </tr>
                </table>
              </div>
            </mat-card-content>
          </div>

          <div class="flex flex-col items-center w-1/5">
            <mat-icon>arrow_forward</mat-icon>
            <br />
            <mat-icon>arrow_forward</mat-icon>
            <br />
            <mat-icon>arrow_forward</mat-icon>
          </div>

          <div class="flex flex-row items-center w-2/5">
            <mat-card-content>
              <div class="flex flex-row">
                Business Destination Merge
              </div>

              <div class="flex flex-col">
                <hr class="w-full" style="border: 1px solid gray;">
                <table>
                  <tr>
                    <td><span style="font-style: bold;">Business Id</span></td>
                    <td>{{mergeBusiness.id}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Business Name</span></td>
                    <td>{{mergeBusiness.businessName}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Business Status</span></td>
                    <td>
                      <span *ngIf="mergeBusiness.active" style="color: green;">Active</span>
                      <span *ngIf="!mergeBusiness.active" style="color: red;">Inactive</span>
                    </td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Address 1</span></td>
                    <td>{{mergeBusiness.businessAddress1}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Address 2</span></td>
                    <td>{{mergeBusiness.businessAddress2}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">City</span></td>
                    <td>{{mergeBusiness.businessCity}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">State</span></td>
                    <td>{{mergeBusiness.stateId}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Zip</span></td>
                    <td>
                      {{mergeBusiness.businessZip}}
                      <span *ngIf="mergeBusiness.businessPhoneExt != null && mergeBusiness.businessPhoneExt != ''">
                        - {{mergeBusiness.businessPhoneExt}}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">County</span></td>
                    <td>{{mergeBusiness.countyName}}</td>
                  </tr>
                  <tr>
                    <td><span style="font-style: bold;">Complaints</span></td>
                    <td>{{mergeBusiness.totalComplaints}}</td>
                  </tr>
                </table>
              </div>
            </mat-card-content>
          </div>
        </div>
        <hr class="w-full" style="border: 1px solid gray;">
        <div class="flex flex-row items-center w-full">
          <mat-icon style="color: red;">warning</mat-icon>
          Are you sure you want to Merge &nbsp; <span style="font-weight: bold;"> {{mergeText}} ? This action cannot be undone.
          </span>
        </div>
        <hr class="w-full" style="border: 1px solid gray;">
        <div class="flex flex-row w-full">
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="back()" class="m-8 container">
              <mat-icon>arrow_back</mat-icon>
              Back
            </button>
          </div>
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="cancel()" class="m-8 container">
              Cancel
            </button>
          </div>
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="saveMerge()" class="m-8 container" style="background: #7ABDF3;">
              Merge <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="showSuccess" class="flex flex-col items-center w-full">
        <mat-card-content>
          <div class="flex flex-row">
            Merged Business Information
          </div>

          <div class="flex flex-col">
            <hr class="w-full" style="border: 1px solid gray;">
            <table>
              <tr>
                <td><span style="font-style: bold;">Business Id</span></td>
                <td>{{mergeBusiness.id}}</td>
              </tr>
              <tr>
                <td><span style="font-style: bold;">Business Name</span></td>
                <td>{{mergeBusiness.businessName}}</td>
              </tr>
              <tr>
                <td><span style="font-style: bold;">Business Status</span></td>
                <td>
                  <span *ngIf="mergeBusiness.active" style="color: green;">Active</span>
                  <span *ngIf="!mergeBusiness.active" style="color: red;">Inactive</span>
                </td>
              </tr>
              <tr>
                <td><span style="font-style: bold;">Address 1</span></td>
                <td>{{mergeBusiness.businessAddress1}}</td>
              </tr>
              <tr>
                <td><span style="font-style: bold;">Address 2</span></td>
                <td>{{mergeBusiness.businessAddress2}}</td>
              </tr>
              <tr>
                <td><span style="font-style: bold;">City</span></td>
                <td>{{mergeBusiness.businessCity}}</td>
              </tr>
              <tr>
                <td><span style="font-style: bold;">State</span></td>
                <td>{{mergeBusiness.stateId}}</td>
              </tr>
              <tr>
                <td><span style="font-style: bold;">Zip</span></td>
                <td>
                  {{mergeBusiness.businessZip}}
                  <span *ngIf="mergeBusiness.businessPhoneExt != null && mergeBusiness.businessPhoneExt != ''">
                    - {{mergeBusiness.businessPhoneExt}}
                  </span>
                </td>
              </tr>
              <tr>
                <td><span style="font-style: bold;">County</span></td>
                <td>{{mergeBusiness.countyName}}</td>
              </tr>
              <tr>
                <td><span style="font-style: bold;">Complaints</span></td>
                <td>{{mergeBusiness.totalComplaints + currentBusiness.totalComplaints}}</td>
              </tr>
            </table>
          </div>
          <hr class="w-full" style="border: 1px solid gray;">
          <div class="flex flex-row w-full">
            <div style="padding-right: 20px;">
              <button mat-raised-button (click)="cancel()" class="m-8 container">
                <mat-icon>arrow_back</mat-icon>
                Back to business list
              </button>
            </div>
          </div>
  
        </mat-card-content>
      </div>

    </div>
  </mat-card-content>
</mat-card>


